module.exports = __webpack_public_path__ + "static/media/BoxArrowUp.f50e8af9.svg";